/**
 * 封装常用的工具函数
 * Created by xupengwei on 2018/6/26.
 * Modified by heyushuang on 2019/9/26.
 */

const returnObj = {
  // 获取浏览器语言
  getBrowserLang() {
    let currentLang = navigator.language;
    if (!currentLang) {
      currentLang = navigator.browserLanguage;
    }
    return currentLang;
  },
  getLan() {
    let queryObj = {};
    let arrTemp = [];
    let lang = this.getBrowserLang();
    let url = new URL(window.location.href);
    console.log(url.searchParams.get('lang'));
    if (url.searchParams.get('lang')) {
      lang = url.searchParams.get('lang');
    }
    switch (lang.substr(0, 2)) {
      case 'zh':
      case 'cn':
        lang = 'zh-hans';
        break;
      case 'en':
      case 'us':
        lang = 'en-us';
        break;
      default:
        lang = 'en-us';
        break;
    }
    console.log('return lang:' + lang);
    return lang;
  },
  // check浏览器环境
  getBrowserEnv() {
    let ua = navigator.userAgent.toLowerCase();
    console.log('getBrowserEnv:');
    console.log(ua);
    let isAndroid = /android|adr/.test(ua) && !(/windows phone/.test(ua));
    let isIos = /iphone|ipad|ipod/.test(ua);
    console.log(isAndroid ? 'Android' : (isIos ? 'IOS' : 'Android'));
    return isAndroid ? 'Android' : (isIos ? 'IOS' : 'Android');
  },
  copyObj(originObj, newObj) {
    let i;
    if (returnObj.isEmptyObject(originObj)) {
      return newObj;
    }
    for (i in originObj) {
      if (typeof originObj[i] === 'object' && !returnObj.isEmptyObject(originObj[i])) {
        if (isNaN(originObj[i].length)) {
          returnObj.copyObj(originObj[i], newObj[i] = {});
        } else {
          newObj[i] = [];
          if (originObj[i].length > 0) {
            returnObj.copyObj(originObj[i], newObj[i] = []);
          }
        }
      } else {
        newObj[i] = originObj[i];
      }
    }
    return newObj;
  },
  isEmptyObject: function (testObj) {
    for (let t in testObj) {
      return !1;
    }
    return !0;
  },
  checkStrParamExisted(str) {
    if (str) {
      return true;
    }
    return false;
  },
  checkApi(data) {
    if (Number(data.code) === 0) {
      return true;
    } else {
      return false;
    }
  },
};

export default returnObj;



// WEBPACK FOOTER //
// ./src/global/util.js